import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const UserSeparationOutlet = lazy(() => import("@/pages/ResignationDetail/UserSeparationOutlet"));
const Resignation = lazy(() => import("@/pages/ResignationDetail/Resignation"));
const ViewNEditUserSeparation = lazy(() => import("@/pages/Users/components/ViewNEditUserSeparation/ViewNEditUserSeparation"));
const UserSeparationChecklist = lazy(() => import("@/pages/ResignationDetail/UserSeparationChecklist"));

const UserSeparationRoute: RouteConfig = {
    path: "user-separation",
    element: <UserSeparationOutlet />,
    pageName: "User Separation",
    sidebar: { show: true, icon: "" },
    permission: ["SeparationView", "ManageChecklist"],
    children: {
        USER_DATA: {
            path: "view",
            element: <Resignation />,
            sidebar: { show: true, icon: "" },
            pageName: "User Separation",
            permission: ["SeparationView"],
        },
        EDIT_USER: {
            path: "edit-separation",
            element: <ViewNEditUserSeparation />,
            pageName: "Separation Details"
        },
        CHECKLIST: {
            path: "checklist",
            element: <UserSeparationChecklist />,
            sidebar: { show: true, icon: "" },
            pageName: "Checklist Details",
            permission: ["ManageChecklist"],
        }
    }
}

export default UserSeparationRoute;